import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploaderComponent } from '@app/shared/components/file-uploader/file-uploader.component';
import { FileUploaderDocumentComponent } from './file-uploader-document/file-uploader-document.component';

@NgModule({
  imports: [CommonModule],
  declarations: [FileUploaderComponent, FileUploaderDocumentComponent],
  exports: [FileUploaderComponent]
})
export class FileUploaderModule {}
